// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  VER_NOME_CLIENTE: true,
  IS_REMOTE_SERVER: false,
  //API_URL: 'https://app-dant.herokuapp.com/v1/',
  //API_URL: 'http://localhost:3000/v1/',
  //API_URL: 'https://shark-app-cg7bq.ondigitalocean.app/',
  //API_URL: 'https://dant-acesso-433611.ue.r.appspot.com/',
  //API_URL: 'http://192.168.1.39:80/v1/',
  //API_URL_GCP: 'https://dant-acesso-api.ue.r.appspot.com/',
  //API_URL_GCP: 'https://dant-acesso-api-910378189939.us-east1.run.app/',

  API_URL: 'https://legacy-api.dant.com.br/v1/',
  API_URL_GCP: 'https://api.dant.com.br/',
  TEMP_TOKEN_GCP: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NjAsImNsaWVudGVfaWQiOjQ0LCJncnVwb19pZCI6MzcsImFsbF9hY2Nlc3MiOmZhbHNlLCJpYXQiOjE3NDUzMzg4NzIsImV4cCI6MTc0NTQyNTI3MiwiYXVkIjoiTm9uZSIsImlzcyI6Ik5vbmUifQ.bI36Mcg3sqd8zl6I4zGVizo_TmhWy7O0G7yWDD2hWec'
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.